/* RESPONSIBLE TEAM: team-ai-insights */
import Insights from 'embercom/routes/apps/app/automation/insights-v2';
import type Transition from '@ember/routing/-private/transition';

export default class FinStandaloneInsights extends Insights {
  analytics = {
    section: 'standalone',
    place: 'insights',
  };

  templateName = 'apps/app/automation/insights-v2';

  activate() {}

  async beforeModel(transition: Transition) {
    if (!this.appService.app.canSeeAiInsightsTopicsV1) {
      this.router.transitionTo('apps.app.standalone.setup');
      return;
    }
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);
  }
}
